import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { isEmpty } from '../../utils/helpers';

const ProtectedRoute = ({
  isAuthenticated,
  component: Component,
  render,
}) => (
  <Route
    render={(props) => {
      if (!isAuthenticated) {
        return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />;
      }
      return Component ? <Component {...props} /> : render(props);
    }}
  />
);

function mapStateToProps(state) {
  const { authenticated } = state.auth;
  return {
    isAuthenticated: !isEmpty(authenticated),
  };
}
export default connect(mapStateToProps)(ProtectedRoute);
